/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Clear_AllInputs */

const es_settings_files_filters_clear_all = /** @type {(inputs: Settings_Files_Filters_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar todo`)
};

const en_settings_files_filters_clear_all = /** @type {(inputs: Settings_Files_Filters_Clear_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear all`)
};

/**
* | output |
* | --- |
* | "Clear all" |
*
* @param {Settings_Files_Filters_Clear_AllInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_clear_all = /** @type {((inputs?: Settings_Files_Filters_Clear_AllInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Clear_AllInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_clear_all(inputs)
	return en_settings_files_filters_clear_all(inputs)
});
export { settings_files_filters_clear_all as "settings.files.filters.clear_all" }